import { createReducer, on } from '@ngrx/store';

import { Profile } from '@mp/auth/profile/domain';

import { ProfileActions, ProfileLoadFailure } from './profile.actions';

export const profileFeatureKey = 'mpauth-core-profile';

export interface ProfileState {
  profile: Profile | null;
  /**
   * Der letzte Profil-Abruf ist endgültig gescheitert, `null` solange nicht. Ohne diesen Ausgang wartet die
   * App-Initialisierung endlos.
   */
  loadFailure: ProfileLoadFailure | null;
}

export const initialState: ProfileState = {
  profile: null,
  loadFailure: null,
};

export const profileReducer = createReducer(
  initialState,
  on(
    ProfileActions.fetchProfile,
    (state): ProfileState => ({
      ...state,
      loadFailure: null,
    }),
  ),
  on(
    ProfileActions.fetchProfileSuccess,
    ProfileActions.updateProfileSuccess,
    (state, { profile }): ProfileState => ({
      ...state,
      profile,
    }),
  ),
  on(
    ProfileActions.fetchProfileError,
    (state, { status, description }): ProfileState => ({
      ...state,
      loadFailure: { status, description },
    }),
  ),
);
